<template>
  <div class="row pt-4 magidei-list">
    <div v-for="magidShiur in magideiShiur" :class="'col pb-3 col-12 col-sm-6 col-md-6 col-xl-' + (colXL || '4')">
      <router-link
        :to="{
          name: routeName(magidShiur.type),
          params: { slug: magidShiur.url_key },
        }"
        class="decoration-none d-flex align-items-center h-100 no-gutters featured-shiurim-card magidei-card"
      >
        <span class="col-5 col-md-4 constrain-height-100">
          <div>
            <b-img-lazy blank-src="/static/blank_profile.jpg" :src="imgsrc(magidShiur)" fluid :alt="magidShiur.name" />
          </div>
        </span>
        <div class="col-7 col-md-8 px-4 py-1 text-left m-auto">
          <span class="magid-shiur-name">
            <highlight v-if="query" :msg="magidShiur.name" :search="query" effect="highlight" />
            <template v-else>{{ magidShiur.name }}</template>
          </span>
          <br />
          <span class="magid-shiur-count"
            ><i v-if="isRTL" class="fa fa-arrow-right"></i> {{ magidShiur.shiurim_count }}
            {{ magidShiur.shiurim_count > 1 ? $_t('KW:shiurim') : $_t('KW:shiur') }} <i v-if="!isRTL" class="fa fa-arrow-right"></i
          ></span>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import HighlightComponent from './../partials/SearchWidget/Highlight.vue';
export default {
  components: {
    Highlight: HighlightComponent,
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'magideiList',
  },
  props: ['magideiShiur', 'type', 'sidebar', 'query', 'colXL'],
  methods: {
    routeName: function (typeOveride) {
      var type = this.type;
      if (typeOveride) {
        type = typeOveride;
      }
      if (type == 'torah') {
        return 'magideiShiurTorah';
      } else if (type == 'shas') {
        return 'magideiShiur';
      } else if (type == 'mishna') {
        return 'magideiShiurMishna';
      }
    },
    imgsrc: function (magidShiur) {
      if (magidShiur.image) {
        return magidShiur.image.thumbnail;
      } else {
        return '/static/blank_profile.jpg';
      }
    },
  },
};
</script>
